export { default } from './PlainPostCard';
